import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getServiceImage } from '../helpers/helpers';

/**
 * Hook compartido para obtener la URL de imagen de un servicio.
 * Usado por ServicioCard (puntoVenta) y ServicioCardReserva (ModalReserva).
 */
export const useServiceImage = (servicio) => {
    const { empresa } = useSelector(state => state.auth);
    const { empresas } = useSelector(state => state.empresas);
    const [imageUrl, setImageUrl] = useState('');

    useEffect(() => {
        if (!servicio?._id) {
            setImageUrl('');
            return;
        }
        let sectorId = null;
        const empresaId = typeof empresa === 'string' ? empresa : empresa?._id;
        if (empresas?.length > 0 && empresaId) {
            const empresaData = empresas.find(e => e._id === empresaId);
            if (empresaData?.sector) {
                sectorId = typeof empresaData.sector === 'string' ? empresaData.sector : empresaData.sector._id;
            }
        }
        const url = getServiceImage(servicio, sectorId);
        if (url?.startsWith('/assets/')) {
            setImageUrl(url);
        } else if (url) {
            setImageUrl(url);
        } else {
            setImageUrl('/assets/img/default-servicio.jpg');
        }
        return () => setImageUrl('');
    }, [servicio, empresa, empresas]);

    return imageUrl;
};
